module.exports = __webpack_public_path__ + "static/media/logo-octocat.3bdb0ef9.svg";